<div class="row ng-scope">
  <div class="col-12">

    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Lý do <span class="cred">(*)</span></label>
      <div class="col-10">
        <textarea type="text" tabIndex="1" #mafocus class="form-control" rows="5" placeholder="" [(ngModel)]="doituongSelect.LyDo"></textarea>
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Ngày<span class="cred">(*)</span></label>
      <div class="col-4">
        <kendo-dateinput tabIndex="2" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.Ngay"></kendo-dateinput>
      </div>
      <label class="control-label col-2 ng-binding">Ng chuyển</label>
      <div class="col-4">
        <input type="text" tabIndex="3" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.CreatedBy">
      </div>

    </div>


    <div class="row form-group">
      <label class="control-label col-2">CN cũ<span class="cred">(*)</span></label>
      <div class="col-4">
        <ng-select #slChiNhanhCu
                   class="twcollong"
                   [tabIndex]="4"
                   [openOnEnter]="false"
                   [items]="dschinhanhs"
                   bindValue="Id"
                   bindLabel="Ten"
                   tabindex="25"
                   [disabled]="true"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   (change)="changeCNCu($event)"
                   [(ngModel)]="doituongSelect.DonViCuId">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <label class="control-label col-2 ng-binding">Lớp cũ<span class="cred">(*)</span></label>
      <div class="col-4">
        <ng-select #slLopCu
                   class="twcollong"
                   [tabIndex]="5"
                   [openOnEnter]="false"
                   [items]="dslopcus"
                   bindValue="Id"
                   bindLabel="Ten"
                   tabindex="26"
                   [disabled]="true"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.LopCuId">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>

    </div>

    <div class="row form-group">
      <label class="control-label col-2">CN mới<span class="cred">(*)</span></label>
      <div class="col-4">
        <ng-select #slChiNhanhCu
                   class="twcollong"
                   [tabIndex]="6"
                   [openOnEnter]="false"
                   [items]="dschinhanhs"
                   bindValue="Id"
                   bindLabel="Ten"
                   tabindex="25"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                    (change)="changeCNMoi($event)"
                   [(ngModel)]="doituongSelect.DonViId">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <label class="control-label col-2 ng-binding">Lớp mới<span class="cred">(*)</span></label>
      <div class="col-4">
        <ng-select #slLopCu
                   class="twcollong"
                   [tabIndex]="7"
                   [openOnEnter]="false"
                   [items]="dslopmois"
                   bindValue="Id"
                   bindLabel="Ten"
                   tabindex="26"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.LopId">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>

    </div>

    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Ghi chú</label>
      <div class="col-10">
        <textarea type="text" tabIndex="9" rows="5" class="form-control" placeholder="" [(ngModel)]="doituongSelect.GhiChu"></textarea>
      </div>
    </div>






  </div>

</div>
<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    
  </div>
  <div class="">
    <button class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="Ấn ESC để thoát" style="padding-top:0px !important">Hủy bỏ</button>
    <button  type="submit" (click)="saveproduct()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">Lưu lại</button>
  </div>

</div>


